import { BankDetails, BeneficiaryDetails, Region } from './reference-book-payment-details.types';

export const regions: Region[] = [
    { id: '1', name: 'АКМОЛИНСКАЯ область' },
    { id: '2', name: 'АКТЮБИНСКАЯ область' },
];

export const beneficiaries: BeneficiaryDetails[] = [
    {
        departmentCode: '0301',
        beneficiaryName: ' ДГД по Акмолинской области ',
        beneficiaryCode: '141140001150',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0302',
        beneficiaryName: ' УГД по Аккольскому району ',
        beneficiaryCode: '940540000528',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0303',
        beneficiaryName: ' УГД по Астраханскому району ',
        beneficiaryCode: '000140001813',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0304',
        beneficiaryName: ' УГД по Атбасарскому району ',
        beneficiaryCode: '940640000492',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0305',
        beneficiaryName: ' УГД по Сандыктаускому району ',
        beneficiaryCode: '050340004626',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0306',
        beneficiaryName: ' УГД по Аршалынскому району ',
        beneficiaryCode: '991240001567',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0307',
        beneficiaryName: ' УГД по Ерейментаускому району ',
        beneficiaryCode: '950340000572',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0308',
        beneficiaryName: ' УГД по Егиндыкольскому району ',
        beneficiaryCode: '961140000232',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0309',
        beneficiaryName: ' УГД по Коргалжынскому району .',
        beneficiaryCode: '021140002283',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0310',
        beneficiaryName: ' УГД по Буландынскому району ',
        beneficiaryCode: '900440000031',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0312',
        beneficiaryName: ' УГД по Целиноградскому району ',
        beneficiaryCode: '910940000071',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0313',
        beneficiaryName: ' УГД по Шортандинскому району ',
        beneficiaryCode: '900440000051',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0316',
        beneficiaryName: ' УГД по г.Степногорску ',
        beneficiaryCode: '021140002134',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0317',
        beneficiaryName: ' УГД по Жаркаинскому району ',
        beneficiaryCode: '961240001086',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0318',
        beneficiaryName: ' УГД по Есильскому району ',
        beneficiaryCode: '961240001036',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0321',
        beneficiaryName: ' УГД по Жаксынскому району ',
        beneficiaryCode: '961240001016',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0323',
        beneficiaryName: ' УГД по Зерендинскому району ',
        beneficiaryCode: '980740001213',
        region: 'АКМОЛИНСКАЯ область',
    },
    {
        departmentCode: '0324',
        beneficiaryName: ' УГД по Бурабайскому району ',
        beneficiaryCode: '980740001362',
        region: 'АКМОЛИНСКАЯ область',
    },

    {
        departmentCode: '0601',
        beneficiaryName: ' ДГД по Актюбинской области ',
        beneficiaryCode: '141140000836',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0604',
        beneficiaryName: ' УГД по Алгинскому району ',
        beneficiaryCode: '980540000991',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0605',
        beneficiaryName: ' УГД по Байганинскому району ',
        beneficiaryCode: '970140000975',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0606',
        beneficiaryName: ' УГД по Айтекебийскому району ',
        beneficiaryCode: '980540000971',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0607',
        beneficiaryName: ' УГД по Иргизскому району ',
        beneficiaryCode: '980640000955',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0609',
        beneficiaryName: ' УГД по Каргалинскому району ',
        beneficiaryCode: '970240000890',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0610',
        beneficiaryName: ' УГД по Мартукскому району ',
        beneficiaryCode: '980540001018',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0612',
        beneficiaryName: ' УГД по Мугалжарскому району ',
        beneficiaryCode: '971040000994',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0613',
        beneficiaryName: ' УГД по Темирскому району ',
        beneficiaryCode: '970140000985',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0614',
        beneficiaryName: ' УГД по Уилскому району ',
        beneficiaryCode: '980640000995',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0615',
        beneficiaryName: ' УГД по Хобдинскому району ',
        beneficiaryCode: '961240000860',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0616',
        beneficiaryName: ' УГД по Хромтаускому району ',
        beneficiaryCode: '980640000975',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0617',
        beneficiaryName: ' УГД по Шалкарскому району ',
        beneficiaryCode: '980640000915',
        region: 'АКТЮБИНСКАЯ область',
    },
    {
        departmentCode: '0618',
        beneficiaryName: ' УГД по г.Актобе ',
        beneficiaryCode: '940740000595',
        region: 'АКТЮБИНСКАЯ область',
    },
];

export const bankDetails: BankDetails = {
    beneficiaryBank: 'ГУ "Комитет казначейства Министерства  финансов РК"',
    bic: 'KKMFKZ2A',
    iban: 'KZ24070105KSN0000000',
};
